// import store from '@/store';

import store from '@/store';

export default class LG {
  /**
   * Wartet bis hcap bereit ist.
   * Auf alten WebOS-Versionen kann hcap noch nicht initialisiert sein
   * wenn die App startet – in diesem Fall auf das 'hcap-ready' Event warten.
   */
  static waitForHcap() {
    return new Promise((resolve) => {
      // hcap kann als globale Variable oder als window.hcap gesetzt sein
      try {
        if (typeof hcap !== 'undefined' && hcap !== null) {
          resolve();
          return;
        }
      } catch (e) { /* hcap noch nicht als Variable definiert */ }
      window.addEventListener('hcap-ready', resolve, { once: true });
    });
  }

  static get tvwindow() {
    if(hcap) return hcap.video;
    if(!window.hcap) return undefined;
    return window.hcap.video;
  }

  static get b2bControl() {
    if(hcap) return hcap.system;
    if(!window.hcap) return undefined;
    return window.hcap.system;
  }

  static get b2bPower() {
    if(hcap) return hcap.power;
    if(!window.hcap) return undefined;
    return window.hcap.power;
  }

  static get b2bMedia() {
    if(hcap) return hcap.media;
    if(!window.hcap) return undefined;
    return window.hcap.media;
  }

  static getModel() {
    return new Promise(async (resolve) => {
      try {
        await LG.waitForHcap();
        hcap.property.getProperty({
          "key": "model_name",
          "onSuccess": (s) => { console.log("onSuccess LG getModel:", s.value); resolve(s.value); },
          "onFailure": (f) => { console.log("onFailure LG getModel:", f.errorMessage); resolve(''); }
        });
      } catch (error) {
        console.log('ERROR - LG.getModel: ', error);
        resolve('');
      }
    });
  }

  static getVersion() {
    // platform_version / hcap_js_extension_version / hcap_middleware_version / micom_version
    return new Promise(async (resolve) => {
      try {
        await LG.waitForHcap();
        hcap.property.getProperty({
          "key": "platform_version",
          "onSuccess": (s) => { console.log("onSuccess LG getVersion:", s.value); resolve(s.value); },
          "onFailure": (f) => { console.log("onFailure LG getVersion:", f.errorMessage); resolve(''); }
        });
      } catch (error) {
        console.log('ERROR - LG.getVersion: ', error);
        resolve('');
      }
    });
  }

  static getIP() {
    return new Promise(async (resolve) => {
      try {
        await LG.waitForHcap();
        hcap.network.getNetworkInformation({
          "onSuccess": (s) => { console.log("onSuccess LG getIP:", s.ip_address); resolve(s.ip_address); },
          "onFailure": (f) => { console.log("onFailure LG getIP:", f.errorMessage); resolve('0.0.0.0'); }
        });
      } catch (error) {
        console.log('ERROR - LG.getIP: ', error);
        resolve('0.0.0.0');
      }
    });
  }

  static getMac() {
    return new Promise(async (resolve) => {
      try {
        await LG.waitForHcap();
        hcap.network.getNetworkDevice({
          "index": 0,
          "onSuccess": (r) => { console.log("onSuccess LG getMac:", r.mac); resolve(r.mac); },
          "onFailure": (r) => { console.log("onFailure LG getMac:", r.errorMessage); resolve('00:00:00:00:00'); }
        });
      } catch (error) {
        console.log('ERROR - LG.getMac: ', error);
        resolve('00:00:00:00:00');
      }
    });
  }

  static getFirmware() {
    return new Promise(async (resolve) => {
      try {
        await LG.waitForHcap();
        hcap.property.getProperty({
          "key": "micom_version",
          "onSuccess": (s) => { console.log("onSuccess LG getFirmware:", s.value); resolve(s.value); },
          "onFailure": (f) => { console.log("onFailure LG getFirmware:", f.errorMessage); resolve(''); }
        });
      } catch (error) {
        console.log('ERROR - LG.getFirmware: ', error);
        resolve('');
      }
    });
  }

  static getWebOSVersion() {
    const ua = navigator.userAgent;
    const match = ua.match(/Web0S\s([\d.]+)/);
    return match ? match[1] : "Unknown";
  }

  static getPlatform() {
    return new Promise(async (resolve) => {
      try {
        await LG.waitForHcap();
        hcap.property.getProperty({
          "key": "hcap_middleware_version",
          "onSuccess": (s) => resolve(s.value),
          "onFailure": () => resolve(LG.getWebOSVersion())
        });
      } catch (error) {
        resolve(LG.getWebOSVersion());
      }
    });
  }

  static getSerial() {
    return new Promise(async (resolve) => {
      try {
        await LG.waitForHcap();
        hcap.property.getProperty({
          "key": "serial_number",
          "onSuccess": (s) => { console.log("onSuccess LG getSerial:", s.value); resolve(s.value); },
          "onFailure": (f) => { console.log("onFailure LG getSerial:", f.errorMessage); resolve(''); }
        });
      } catch (error) {
        console.log('ERROR - LG.getSerial: ', error);
        resolve('');
      }
    });
  }

  static get getResolutionHeight() {
    try {
      /*
      const resolution = tizen.systeminfo.getPropertyValue("DISPLAY", function(disp) {
        //console.log("==============DISPLAY-H", disp);
        //return {width: disp.resolutionWidth, height: disp.resolutionHeight};
        return disp.resolutionHeight;
      });
      return resolution;
      */
      return screen.height;
    } catch (error) {
      console.log(' error code = ' + error.code);
      return '';
    }
  }
  static get getResolutionWidth() {
    try {
      /*
      const resolution = tizen.systeminfo.getPropertyValue("DISPLAY", function(disp) {
        //console.log("==============DISPLAY-W", disp);
        //return {width: disp.resolutionWidth, height: disp.resolutionHeight};
        return disp.resolutionWidth;
      });
      return resolution;
      */
      return screen.width;
    } catch (error) {
      console.log(' error code = ' + error.code);
      return '';
    }
  }

  /*
  static set setSystemConfig(value) {
    try {
      webapis.productinfo.setSystemConfig(webapis.productinfo.ProductInfoConfigKey.CONFIG_KEY_DATA_SERVICE, value, onsuccess, onerror);
      return true;
    } catch (error) {
      console.log("ERRROR: Tizen setSystemConfig data = " + error.code);
      return false;
    }
  }

  static onsuccess(data)  {
    console.log("SUCCESS: Tizen setSystemConfig data = " + data);
  }
  static onerror(error)  {
    console.log("error code : " + error.code);
  }
  */

  static PowerState() {
    /*
    try {
      const PowerState = this.b2bPower.getPowerState();
      store.dispatch('notification/new', {
        title: 'Power State',
        message: PowerState,
      });
    } catch (e) {
      store.dispatch('notification/new', {
        title: e.name,
        message: e.message,
      });
      console.log(
        '[getPowerState] call syncFunction exception [' +
          e.code +
          '] name: ' +
          e.name +
          ' message: ' +
          e.message
      );
    }
    */
    hcap.power.getPowerMode({
      "onSuccess": function (s) {
          console.log("onSuccess power mode " + s.mode);
          store.dispatch('notification/new', {
            title: 'Power State',
            message: s.mode,
          });
      },
      "onFailure": function (f) {
          console.log("[getPowerMode] call syncFunction exception = " + f.errorMessage);
          store.dispatch('notification/new', {
            title: e,
            message: e.errorMessage,
          });
      }
    });
  }
  static callbackSuccess(name, context) {
    console.log('CALLBACK_SUCCESS: ', name, ' with context: ', context);
  }
  static callbackError(name, context) {
    console.log('CALLBACK_ERROR: ', name, ' with context: ', context);
  }
  static turnOff() {
    //const cbSuccess = () => this.callbackSuccess('turnOff');
    //const cbError = () => this.callbackError('turnOff');
    //this.b2bControl.setPowerOff(cbSuccess, cbError);
    hcap.power.powerOff({
      "onSuccess": function () {
          console.log("onSuccess: turnOff");
      },
      "onFailure": function (f) {
          console.log("onFailure turnOff: errorMessage = " + f.errorMessage);
      }
    });
  }
  static turnOn() {
    //const cbSuccess = () => this.callbackSuccess('turnOn');
    //const cbError = (err) => this.callbackError('turnOn', err);
    //// this.PowerState();
    //// console.log('STATE: ', this.PowerState());
    //this.b2bPower.setPowerOn(cbSuccess, cbError);
    hcap.power.setPowerMode({
      "mode": hcap.power.PowerMode.NORMAL,
      "onSuccess": function () {
          console.log("onSuccess turnOn");
      },
      "onFailure": function (f) {
          console.log("onFailure turnOn: errorMessage = " + f.errorMessage);
      }
    });
  }

  static reboot() {
    //const cbSuccess = () => this.callbackSuccess('reboot');
    //const cbError = (err) => this.callbackError('reboot', err);
    //this.b2bControl.rebootDevice(cbSuccess, cbError);
    hcap.power.reboot({
      "onSuccess": function () {
          console.log("Success to reboot");
      },
      "onFailure": function (f) {
          console.log("Fail to reboot : " + f.errorMessage);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/helpers/Device/LG.js